import { Checkbox } from "@productlane/ui"

interface Props {
	checked: boolean | "indeterminate"
	onCheckedChange: (checked: boolean | "indeterminate") => void
	label: string
	// Shift-click selects a range instead of toggling this one row.
	onShiftClick?: () => void
}

// Radix toggles on the click before it reaches this wrapper, which then swallows
// it so the row link around the checkbox does not navigate.
export function SelectionCheckbox({
	checked,
	onCheckedChange,
	label,
	onShiftClick,
}: Props) {
	return (
		<span
			role="presentation"
			className="flex flex-none items-center"
			onClickCapture={(event) => {
				if (!event.shiftKey || !onShiftClick) return
				event.preventDefault()
				event.stopPropagation()
				onShiftClick()
			}}
			onClick={(event) => {
				event.preventDefault()
				event.stopPropagation()
			}}
		>
			<Checkbox
				size="sm"
				className="cursor-default"
				aria-label={label}
				checked={checked}
				onCheckedChange={onCheckedChange}
			/>
		</span>
	)
}
